import React = require('react');
import {IChoice} from "./models";
import {getChoiceName} from "./utils";

interface Properties {
    choice: IChoice|string
    isSelected?: boolean
}

interface Callbacks {
    onClick: (choice: IChoice|string) => void
}

interface Props extends Properties, Callbacks {}

interface State {
}

export class Choice extends React.Component<Props, State> {

    handleClick() {
        this.props.onClick( this.props.choice );
    }

    render() {

        var image;
        if (typeof this.props.choice !== "string") {
            var choice : IChoice = this.props.choice as IChoice;

            if (choice.image) {
                image = <div className="cc-choice__image-wrapper">
                    <img className="cc-choice__image" src={choice.image}/>
                </div>;
            }
        }

        var extraClasses = this.props.isSelected ? ' -cc-selected' : '';

        if (image) {
            extraClasses += ' -cc-has-image';
        }

        var tick = <i className="cc-choice__tick glyphicon glyphicon-ok"/>;

        return <div className={"cc-choice" + extraClasses} onClick={this.handleClick.bind(this)}>
            {image}
            <div className="cc-choice__text">
                {tick}
                {getChoiceName(this.props.choice)}
            </div>
        </div>;
    }
}
